"use client";

import { useEffect, useRef } from "react";
import { useGlobalFilters } from "@/contexts/GlobalFilterContext";
import { Button } from "@/components/ui/Button";
import { X } from "lucide-react";
import { useTranslations } from "next-intl";
import { HorizontalContainer } from "@/components/layout/containers/HorizontalContainer";

const AUTO_DISMISS_MS = 8000;

export function GlobalFilterPrompt() {
  const { pendingChange, acceptPendingChange, dismissPendingChange } = useGlobalFilters();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const t = useTranslations();

  useEffect(() => {
    if (!pendingChange) return;
    timerRef.current = setTimeout(() => {
      dismissPendingChange();
    }, AUTO_DISMISS_MS);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [pendingChange, dismissPendingChange]);

  if (!pendingChange) return null;

  return (
    <HorizontalContainer className="justify-center border-b border-blue-200 bg-blue-50 px-4 py-2 text-sm gap-3">
      <span className="text-blue-800">{pendingChange.label}</span>
      <Button
        size="sm"
        variant="default"
        className="h-7 px-3 text-xs"
        onClick={acceptPendingChange}
      >
        {t("general.apply")}
      </Button>
      <Button
        size="sm"
        variant="ghost"
        className="h-7 px-2 text-xs text-blue-600"
        onClick={dismissPendingChange}
      >
        <X className="h-3 w-3" />
      </Button>
    </HorizontalContainer>
  );
}
